import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

interface LabelProps {
  $left: number;
  $top: number;
}

export default styled.label<LabelProps>(
  ({ $left, $top }: LabelProps) => css`
    background-color: ${Theme.color.white};
    font-weight: ${Theme.font.weight.bold};
    transform: translate(-50%, -50%);

    font-size: ${Theme.rems(10)};
    color: ${Theme.color.black};

    border-radius: 80px;
    position: absolute;

    padding: 4px 12px;
    left: ${$left}px;
    top: ${$top}px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 55px;
  `
);
